import { createAction } from 'redux-act';
import { createResource } from '@gandi/resource/redux';
export const resource = createResource('places');
export const setLastAskedCountry = createAction('Set last asked country');
export const fetchCountryList = () => dispatch => dispatch(resource.fetch('/address/countries'));
export const fetchCountry = (country, bu) => dispatch => {
  const label = bu ? `${country}-${bu}` : country;
  dispatch(setLastAskedCountry(label));
  const options = {
    label,
    params: {}
  };
  if (bu) {
    options.params.bu = bu;
  }
  return dispatch(resource.fetchOne(`/address/countries/${country}`, options));
};